import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  Renderer2,
} from '@angular/core';
import { Subject, Subscription } from 'rxjs';

@Directive({
  selector: '[blockOnClickEvent]',
})
export class BlockOnClickEvent {
  @Input() condition = false;
  @Input() requestCategory = '';
  @Input() callback:
    | Subject<{ isOpen: boolean; requestCategory: string }>
    | undefined;
  @Output('click.checkBlockEvent') handler = new EventEmitter<Event>();

  @HostListener('click', ['$event'])
  public onClick(event: any): void {
    if (this.condition) {
      event.stopPropagation();
      if (this.callback) {
        this.callback.next({
          isOpen: true,
          requestCategory: this.requestCategory,
        });
      }
    }
  }
  private listenerFn: () => void;

  constructor(private renderer: Renderer2, private element: ElementRef) {}

  ngOnInit() {
    this.listenerFn = this.renderer.listen(
      this.element.nativeElement,
      'click',
      (event) => {
        if (this.condition) {
          event.stopPropagation();
          return;
        }
        this.handler.emit(event);
      }
    );
  }

  ngOnDestroy() {
    this.listenerFn();
  }
}
